/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum QuoteOfferStatus {
    Offered = 0,
    Declined = 1,
    Accepted = 2,
    Timeout = 3,
    Rejected = 4,
    Withdrawn = 5,
    Retracted = 6,
}
